import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,DateField,BooleanField,NumberField
 }
from 'admin-on-rest/lib/mui';

export const CHBAlertsList = (props) => (
    <List title="CHB  - התראות" {...props}>
        <Datagrid>
            
            
        <TextField label="בית עסק " source="buisiness_id"/> 
           <NumberField label="ממוצע עסקאות חודשי"  source="total"  locales="he-IL" options={{ style: 'currency', currency: 'USD' }}/>
           
           
           <NumberField label="מספר עסקאות" source="chb_count"  />
           <NumberField label="סהכ CHB" source="totalIskot"  locales="he-IL" options={{ style: 'currency', currency: 'USD' }}/>
           <NumberField label="שנה " source="year"/>
           <NumberField label="חודש " source="month"/>
           
           <NumberField  label="יחס CHB/מחזור" source="ratio" locales="he-IL" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
           <BooleanField label="מעל 75 " source="chbAlert2" />
           <BooleanField label="מעל 0.75% " source="chbAlert1"/>
           

            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.id}` : ''}</span>;
};

       
         





              



// WEBPACK FOOTER //
// ./src/components/CHB/chbAlerts.js